// import { Toast } from 'mint-ui'
import { Toast } from 'vant'
export function showMessage (content, type, className, iconClass) {
  Toast({
    message: content,
    duration: 1500
  })
}
